export default __webpack_public_path__ + "static/media/twicon.a87e4ca7.svg";